import Rest from '@/services/Rest';

/**
 * @typedef {ReleaseRuleService}
 */
export default class ReleaseRuleService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/release-rules'
}
